// src/components/CSVImportModal.js
import React, { useState } from "react";
import axios from "axios";
import "./CSVImportModal.css";

const CSVImportModal = ({ type, isOpen, onClose, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState("");

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile || null);
    setStatusMessage("");
    setStatusType("");
  };

  const handleSelectClick = () => {
    document.getElementById("csvFileInput").click();
  };

  const handleImport = async () => {
    if (!file) {
      setStatusMessage("No file selected!");
      setStatusType("error");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    let backendUrl;
    if (type === "patients") {
      backendUrl = `${process.env.REACT_APP_BACKEND_URL}/patients/upload_csv/`;
    } else if (type === "studies") {
      backendUrl = `${process.env.REACT_APP_BACKEND_URL}/patients/studies/upload_csv/`;
    } else if (type === "dicoms") {
      backendUrl = `${process.env.REACT_APP_BACKEND_URL}/patients/dicoms/upload_csv/`;
    } else if (type === "fsa_labels") {
      backendUrl = `${process.env.REACT_APP_BACKEND_URL}/patients/fsa_labels/upload_csv/`;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(backendUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      });
      setStatusMessage(response.data.message);
      setStatusType("success");
      if (onSuccess) onSuccess(response.data);
    } catch (error) {
      console.error(error);
      setStatusMessage("Error uploading CSV");
      setStatusType("error");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">IMPORT {type === "dicoms" ? "XA " : ""}{type.toUpperCase()}</h2>

        <div className="file-input-row">
          <span className="file-input-text">
            {file ? file.name : "Select a file .csv (UTF-8 Encoding)"}
          </span>
          <button className="btn btn-select" onClick={handleSelectClick}>
            SELECT
          </button>
          <input
            id="csvFileInput"
            type="file"
            accept=".csv"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>

        {statusMessage && (
          <div className={`status-msg ${statusType}`}>{statusMessage}</div>
        )}

        <div className="modal-actions">
          <button className="btn btn-cancel" onClick={onClose}>
            CANCEL
          </button>
          <button
            className="btn btn-import"
            onClick={handleImport}
            disabled={!file}
          >
            IMPORT
          </button>
        </div>
      </div>
    </div>
  );
};

export default CSVImportModal;
